// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4872":"a5429789","5151":"dc801bf2"}[chunkId] + ".chunk.css";
};